export default [{
  path: '/synchronization',
  name: 'synchronization',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/synchronization/index')
}]
